import {
  DASHBOARD_SIGNATURES_MAX_PER_PAGE,
  DASHBOARD_SIGNATURES_PAGE_SIZE,
} from "../constants/dashboardListPagination";
import { OwnerDocumentStatusFilter } from "../types/ownerDashboard.types";

export interface PendingSignaturesQuery {
  status: OwnerDocumentStatusFilter;
  page: number;
  perPage: number;
}

function clampPositiveInt(value: number, fallback: number, max?: number): number {
  const parsed = Number.isFinite(value) ? Math.floor(value) : fallback;
  const minimum = Math.max(1, parsed);
  return max == null ? minimum : Math.min(max, minimum);
}

export function buildPendingSignaturesParams(
  query: PendingSignaturesQuery
): Record<string, string> {
  return {
    status: query.status,
    page: String(clampPositiveInt(query.page, 1)),
    per_page: String(
      clampPositiveInt(
        query.perPage,
        DASHBOARD_SIGNATURES_PAGE_SIZE,
        DASHBOARD_SIGNATURES_MAX_PER_PAGE
      )
    ),
  };
}
